var exports = {
  "S": "ProfileEffectOverlay.module__image___Mms1en",
};

module.exports = exports;
